export const MAX_PROPERTY_ROOM_RATES_TO_SHOW = 100
